import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Home from "@/pages/Home";
import Plumbers from "@/pages/Plumbers";
import Electricians from "@/pages/Electricians";
import Roofers from "@/pages/Roofers";
import Contractors from "@/pages/Contractors";
import Admin from "@/pages/Admin";
import Portal from "@/pages/Portal";
import Signup from "@/pages/Signup";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Compare from "@/pages/Compare";
import Resources from "@/pages/Resources";
import Demo from "@/pages/Demo";
import Playground from "@/pages/Playground";
import LandingAd from "@/pages/LandingAd";
import { initGtag } from "@/lib/gtag";
import AuthCallback from "@/components/AuthCallback";
import ChatWidget from "@/components/ChatWidget";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/plumbers" element={<Plumbers />} />
      <Route path="/electricians" element={<Electricians />} />
      <Route path="/roofers" element={<Roofers />} />
      <Route path="/contractors" element={<Contractors />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/portal" element={<Portal />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/compare" element={<Compare />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/demo" element={<Demo />} />
      <Route path="/playground" element={<Playground />} />
      <Route path="/lp/missed-call-text-back" element={<LandingAd />} />
    </Routes>
  );
};

function App() {
  useEffect(() => {
    initGtag();
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-[#0B0D10] text-slate-50 antialiased overflow-x-clip">
      <Toaster theme="dark" position="bottom-right" />
      <BrowserRouter>
        <ScrollToTop />
        <AppRouter />
        <ChatWidget />
      </BrowserRouter>
    </div>
  );
}

export default App;
